import {EditordocService, type EmployeeLdap} from 'client';
import {useCollabContext, usePlanningId} from 'components/DSYS/CollabProvider';
import type {
  DynamicNodeDefinition,
  DynamicNodeRenderProps,
} from 'components/DSYS/editor/dynamicNode/types';
import typeaheadStyles from 'components/DSYS/editor/nodes/TypeaheadNode.module.css';
import {useEffect} from 'react';
import {getService} from 'utilities';
import {EmployeeSelect} from 'views/workstreams/TODODSYSStuff';

const DocOwner = ({editor, value, setValue}: DynamicNodeRenderProps) => {
  const {collabOwner} = useCollabContext();
  const planningId = usePlanningId();

  useEffect(() => {
    if (collabOwner) {
      setValue(collabOwner);
    }
  }, [collabOwner, setValue]);

  const handleEmployeeSelection = (selection?: EmployeeLdap) => {
    if (!selection) {
      return;
    }
    setValue(selection);
    if (planningId) {
      void getService(EditordocService).updateApiV1EditordocEncryptedIdPut(planningId, {
        owner_id: selection.user_id,
      });
    }
  };

  if (!value && !editor.isEditable()) {
    return null;
  }

  return (
    <EmployeeSelect
      selection={value as EmployeeLdap}
      setSelection={handleEmployeeSelection}
      disabled={!editor.isEditable()}
      inputClassName={typeaheadStyles.employeeTypeaheadInput}
    />
  );
};

export const docOwnerDefinition: DynamicNodeDefinition = {
  kindId: 'doc_owner',
  labelKey: 'typeahead_owner',
  categoryKey: 'dynamic_node_category_document',
  defaultBinding: {kind: 'doc_owner'},
  Component: DocOwner,
  exportHtml: ({value}) => (value as EmployeeLdap | undefined)?.name ?? '',
};
